//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, email } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import { date } from "quasar";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQRadio from "@/components/Generics/AQRadio/AQRadio.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import { APP_DATE_DOT_DMY_FORMAT } from "@/assets/js/appConfig";

export default {
    components: {
        AQModal,
        AQDialog,
        AQRadio,
        AQInput,
        AQCard,
        AQTooltip
    },
    props: {
        delegationDetails: {
            type: Object,
            default: () => {}
        },
        fromEdit: {
            type: Boolean,
            default: false
        }
    },
    validations: {
        delegationDetail: {
            selectedAssignee: {
                required,
                email
            }
        }
    },
    data() {
        return {
            open: true,
            save: {
                label: this.$t("userProfile.delegationModal.saveBtn"),
                disabled: false
            },
            dateFormat: APP_DATE_DOT_DMY_FORMAT,
            delegationDetail: {
                startDate: "",
                endDate: "",
                selectedAssignee: "",
                oldTaskCheckbox: true,
                id: "",
                status: ""
            },
            invalidStartDate: false,
            invalidEndDate: false,
            invalidAssignee: false,
            showDialog: false,
            isDisabled: false,
            optionsMenu: "",
            firstLoad: true,
            initialData: "",
            today: "",
            keepTasks: false,
            currentUser: ""
        };
    },
    computed: {
        ...mapGetters("userProfile", ["getUserId", "getDelegationId", "getUserEmail"]),
        modalTitle() {
            return this.fromEdit ? this.$t("userProfile.delegationModal.editDelegationTitle") : this.$t("userProfile.delegationModal.newDelegationTitle");
        },
        emailErrorMessage() {
            let errMsg = "";
            if (!this.$v.delegationDetail.selectedAssignee.required) {
                errMsg = this.$t("userProfile.delegationModal.requiredEmail");
            } else if (this.currentUser === this.delegationDetail.selectedAssignee) {
                errMsg = this.$t("userProfile.delegationModal.currentUserError");
            } else if (!this.$v.delegationDetail.selectedAssignee.email) {
                errMsg = this.$t("admin.usersAndRoles.manualAddModal.invalidEmail");
            }
            return errMsg;
        },
        delegationAccepted() {
            return this.fromEdit && this.delegationDetail.status === "ACC";
        }
    },
    created() {
        this.getToday();
        this.currentUser = this.getUserEmail;
        this.delegationDetail.startDate = this.delegationDetails.startDate;
        this.delegationDetail.endDate = this.delegationDetails.endDate;
        this.delegationDetail.oldTaskCheckbox = this.fromEdit ? this.delegationDetails.isImmediate : true;
        this.delegationDetail.selectedAssignee = this.delegationDetails.delegatedUser;
        this.delegationDetail.status = this.delegationDetails.status;
        this.initialData = { ...this.delegationDetail };
        this.initialData = JSON.stringify(this.initialData);
        const startDate = date.formatDate(this.delegationDetail.startDate, "YYYY/MM/DD");
        if (this.delegationAccepted && startDate <= this.today) {
            this.isDisabled = true;
        }
    },
    methods: {
        ...mapActions("userProfile", ["saveDelegation", "getDelegation"]),
        actionsDlg($event) {
            if ($event === "save") {
                this.emailBlur();
                if (this.invalidAssignee) {
                    return false;
                } if (!this.delegationDetail.startDate) {
                    this.invalidStartDate = true;
                    return false;
                } if (!this.delegationDetail.endDate) {
                    this.invalidEndDate = true;
                    return false;
                }
                if (this.invalidStartDate || this.invalidEndDate || this.invalidAssignee) {
                    return false;
                }
                this.save.disabled = true;
                const startDate = this.delegationDetail.startDate.split("+")[0];
                const endDate = `${this.delegationDetail.endDate.split("T")[0]}T23:59:00.000`;
                const payload = {
                    userId: this.getUserId,
                    username: this.getUserEmail,
                    startDate,
                    endDate,
                    isImmediate: this.delegationDetail.oldTaskCheckbox,
                    delegateUsername: this.delegationDetail.selectedAssignee
                };
                if (this.fromEdit) {
                    payload.id = this.getDelegationId;
                    if (JSON.stringify(this.delegationDetail) !== this.initialData) {
                        payload.status = "PEN";
                    }
                }
                this.saveDelegation(payload).then(() => {
                    this.getDelegation(this.getUserId);
                    this.open = false;
                    this.$emit("delegationDetails", { payload, delegatedUserName: this.delegationDetail.selectedAssignee });
                    this.$emit("modalClosed", false);
                    this.$toast.showNotify({
                        type: "success",
                        message: this.fromEdit
                            ? this.$t("userProfile.delegationModal.delegationEdited") : this.$t("userProfile.delegationModal.delegationCreated"),
                        timeout: 500
                    });
                }).catch(() => {
                    this.save.disabled = false;
                });
            } else {
                const currentData = JSON.stringify(this.delegationDetail);
                if ($event === "backdrop") {
                    this.open = true;
                } else if (currentData === this.initialData) {
                    this.open = false;
                    this.$emit("modalClosed", false);
                } else {
                    this.showDialog = true;
                }
            }
            return false;
        },
        dialogConfirmAction() {
            this.open = false;
            this.$emit("modalClosed", false);
        },
        getToday() {
            const currentDate = new Date();
            this.today = `${currentDate.getFullYear()
            }-${
                this.formatDate(currentDate.getMonth() + 1)
            }-${
                this.formatDate(currentDate.getDate())}`;
            this.today = date.formatDate(this.today, "YYYY/MM/DD");
        },
        checkStartDate() {
            this.invalidStartDate = !this.delegationDetail.startDate;
        },
        checkEndDate() {
            this.invalidEndDate = !this.delegationDetail.endDate;
        },
        startDateInput() {
            this.clearEndDate();
            this.checkStartDate();
        },
        formatDate(value) {
            return value < 10 ? `0${value}` : value;
        },
        clearEndDate() {
            if (new Date(this.delegationDetail.startDate) > new Date(this.delegationDetail.endDate)) {
                this.delegationDetail.endDate = "";
            }
        },
        startDateOptions(selectableDate) {
            return selectableDate >= this.today;
        },
        endDateOptions(selectableDate) {
            const startDate = date.formatDate(this.delegationDetail.startDate, "YYYY/MM/DD");
            return (startDate && selectableDate >= startDate && selectableDate >= this.today) || (!startDate && selectableDate >= this.today);
        },
        emailBlur() {
            this.invalidAssignee = this.$v.delegationDetail.selectedAssignee.$invalid || this.$v.delegationDetail.selectedAssignee.$error
            || this.currentUser === this.delegationDetail.selectedAssignee;
        }
    }
};
